import React from 'react'
import { Avatar, Card, CardContent, CardHeader, Grid, Typography, makeStyles } from '@material-ui/core'
import { logoSrc } from '../../api/logoSrc'
import { toFarsiDigits } from '../../assets/utils'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#f1f1f1',
    flexGrow: 1,
    marginBottom: theme.spacing(3),
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  avatar: {
    width: 64,
    height: 64,
    fontSize: 24,
    background: '#8fa8f8',
    color: '#fff',
  },
  logo: {
    width: 64,
    height: 64,
    borderRadius: 8,
    objectFit: 'contain',
    border: '1.5px solid #e3e6f2',
    background: '#fff',
  },
  name: { fontWeight: 700, fontSize: 17 },
  code: { color: '#5a6b8c', fontSize: 13.5, marginTop: 2 },
}))

/**
 * کارتِ مشخصاتِ کاربر در بالای پنل:
 * لوگو/عکس + نام + شناسه ملی (یا کد ملیِ ناظر)
 */
export default function UserProfileCard({
  title = 'مشخصات کاربر',
  name,
  code,
  codeLabel = 'شناسه ملی',
  logo,
  extra,
}) {
  const classes = useStyles()
  const codeText = code ? toFarsiDigits(code) : '—'

  return (
    <Card elevation={5} className={classes.root} data-tour="profile-card">
      <CardHeader title={title} />
      <CardContent>
        <div className={classes.head}>
          {logo ? (
            <img
              src={logoSrc(logo)}
              alt=""
              className={classes.logo}
              onError={(e) => { e.target.style.display = 'none' }}
            />
          ) : (
            <Avatar className={classes.avatar}>{(name || 'ک').trim().charAt(0)}</Avatar>
          )}
          <div>
            <Typography className={classes.name}>{name || '—'}</Typography>
            <Typography className={classes.code}>{codeLabel}: {codeText}</Typography>
          </div>
        </div>
        {extra ? <Grid container style={{ marginTop: 14 }}>{extra}</Grid> : null}
      </CardContent>
    </Card>
  )
}
